import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters, FormatPhoneNumber } from '../../../common/Utils'
import { description } from 'devexpress-dashboard/model/index.metadata';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { IM, WM } from '../../../const/constants';
import form from '../../../wm/components/transactions/dataentry/form';
import '../../../common/css/searchPage.css';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const SearchLayout = {
    "groupId": 1,
    "fields": [
        {
            "name": "IdentityId",
            "tableName": "IMLOCATION",
            "label": "Warehouse",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }, {
            "name": "CapacityUnits",
            "tableName": "IMLOCATION",
            "label": "Capacity Units",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }, {
            "name": "Status",
            "tableName": "IMLOCATION",
            "label": "Status",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        }
    ]
}

const LocationHistoryList = (props) => {
    const dataGrid = useRef(null);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "A5E3D3E2-93FD-4FDE-B894-E18EC51715B2";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        RItem: props.RItem,
        RLot: props.RLot,
    };

    const [formFields, setformFields] = useState(initialFormFields);

    const handleFormLoad = useCallback(() => { }, []);

    const handleSearch = (e) => {
        e.event.stopPropagation();
        loadData();
    }
const loadData = () => {
    const fieldTypes ={
        RItem: 'select',
        RLot: 'select',
    }
    let datasource = loadDatasource(formFields);
    const filters = buildDxFilters(formFields,fieldTypes);
    datasource.filter(filters);
    setResultData(datasource);
}
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setResultData(loadDatasource(initialFormFields));
    }

    useEffect(() => {
        loadData();
    }, []);
    // Handle grid row selection to enable/disable Edit button
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const loadDatasource = (filters) => {
        let store = createStore({
            key: 'Rowid',
            loadParams: filters,
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.IM.GetTransactionLocationHistory}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);


    const handleFieldValueChanged = (name, value, event) => { console.log(name, value, event) }

    const handleSelectedItemChanged = (name, event) => {
        console.log(name, event);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <DataGrid

                            onExporting={(e) => {
                                if (window.handleDevExtremeDataGridExport) {
                                    window.handleDevExtremeDataGridExport(e);
                                }
                            }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={searchPanelStatus ? "Popup-XL-GridHeight " : "GridHeightAccordianClose"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <ColumnHeaderFilter />
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            {/* Visible columns in order per grid layout */}
                            <Column dataType="string" dataField="warehousecode" caption="WH Location" />
                            <Column dataType="string" dataField="locationcode" caption="Location" />
                            <Column dataType="number" dataField="OnHand" caption="On-Hand" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="datetime" dataField="CreationDateTime" caption="Creation" format='MM/dd/yyyy'/>
                            <Column dataType="number" dataField="InReceiving" caption="In-Rec" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="OutShipped" caption="In-Shp" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="AvlCalc" caption="Avl" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="NetAvlCalc" caption="Net-Avl" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="InFuture" caption="Fut-Rec" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="OutFuture" caption="Fut-Shp" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="string" dataField="Source" caption="Source" />
                            <Column
                                dataField="AvailablelBalance" 
                                caption="Avl-Bal"
                                calculateCellValue={(rowData) => {
                                    const onHand = Number(rowData.OnHand) || 0;
                                    const inReceiving = Number(rowData.InReceiving) || 0;
                                    const outShipped = Number(rowData.OutShipped) || 0;
                                    return onHand + inReceiving - outShipped;
                                }}
                                dataType="number"
                                format={{ type: 'fixedPoint', precision: 2 }}
                            />
                            <Column
                                dataField="NetAvailablelBalance"
                                caption="NetAvl-Bal"
                                calculateCellValue={(rowData) => {
                                    const onHand = Number(rowData.OnHand) || 0;
                                    const inReceiving = Number(rowData.InReceiving) || 0;
                                    const outShipped = Number(rowData.OutShipped) || 0;
                                    const inOrdered = Number(rowData.InOrdered) || 0;
                                    const outOrdered = Number(rowData.OutOrdered) || 0;
                                    return  onHand+inReceiving- outShipped + inOrdered - outOrdered;
                                }}
                                dataType="number"
                                format={{ type: 'fixedPoint', precision: 2 }}
                            />
                            {/* Hidden columns */}
                            <Column dataType="datetime" dataField="Transactiondate" caption="Transaction Date" visible={false} format='MM/dd/yyyy' />
                            <Column dataType="number" dataField="Quantityinventory" caption="Quantity Inventory" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="string" dataField="Quantityinventoryuom" caption="Quantity Inventory UOM" visible={false} />
                            <Column dataType="string" dataField="Comment" caption="Comment" visible={false} />
                            <Column dataType="number" dataField="InOrdered" caption="In Ordered" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="InBackorder" caption="Backorder Receiving" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="OutOrdered" caption="Out Ordered" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="OutBackorder" caption="Backorder Shipping" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="string" dataField="Status" caption="Status" visible={false} />
                            <Column dataType="boolean" dataField="Availableflag" caption="Available Flag" visible={false} />
                            <Column dataType="string" dataField="Availablereasoncode" caption="Reason" visible={false} />
                            <Column dataType="number" dataField="InUnavailable" caption="In Unavailable" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="OutUnavailable" caption="Out Unavailable" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="string" dataField="Sourcetablename" caption="Source Table Name" visible={false} />
                            <Column dataType="number" dataField="Originalquantity" caption="Original Quantity" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Netweight" caption="Net Weight" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Grossweight" caption="Gross Weight" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="locationId" caption="Location Id" visible={false} />
                            <Column dataType="number" dataField="warehouseId" caption="Warehouse Id" visible={false} />
                            <Column dataType="string" dataField="ItemType" caption="Item Type" visible={false} />
                            <Column dataType="number" dataField="ItemAvailable" caption="Item Available" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="ItemNetAvailable" caption="Item Net Available" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="LotAvailable" caption="Lot Available" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
                            <Column dataType="number" dataField="LotNetAvailable" caption="Lot Net Available" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="IMTransactionHeaderKS" caption="IM Transaction Header KS" visible={false} />
                            <Column dataType="string" dataField="ReasonDescription_1" caption="Reason Description 1" visible={false} />
                            <Column dataType="string" dataField="ReasonDescription_2" caption="Reason Description 2" visible={false} />
                            <Column dataType="string" dataField="WarehouseLocationName" caption="WH Name" visible={false} />
                            <Column dataType="string" dataField="ITEMCODE" caption="Item" visible={false} />
                            <Column dataType="string" dataField="ItemDesc_1" caption="Item Desc 1" visible={false} />
                            <Column dataType="string" dataField="ItemDesc_2" caption="Item Desc 2" visible={false} />
                            <Column dataType="string" dataField="LOTCODE" caption="Lot" visible={false} />
                            <Column dataType="string" dataField="LotDesc_1" caption="Lot Desc 1" visible={false} />
                            <Column dataType="string" dataField="LotDesc_2" caption="Lot Desc 2" visible={false} />
                            <Column dataType="string" dataField="LocationDesc" caption="Location Description" visible={false} />
                            <Column dataType="string" dataField="DIMENSIONS" caption="Dimensions" visible={false} />
                            <Column dataType="string" dataField="Code_1_Location" caption="Code 1 Location" visible={false} />
                            <Column dataType="string" dataField="Code_2_Location" caption="Code 2 Location" visible={false} />
                            <Column dataType="string" dataField="Code_3_Location" caption="Code 3 Location" visible={false} />
                            <Column dataType="string" dataField="Code_4_Location" caption="Code 4 Location" visible={false} />
                            <Column dataType="string" dataField="Code_5_Location" caption="Code 5 Location" visible={false} />
                            <Column dataType="string" dataField="Code_6_Location" caption="Code 6 Location" visible={false} />
                            <Column dataType="string" dataField="Code_7_Location" caption="Code 7 Location" visible={false} />
                            <Column dataType="string" dataField="Code_8_Location" caption="Code 8 Location" visible={false} />
                            <Column dataType="string" dataField="Code_9_Location" caption="Code 9 Location" visible={false} />
                            <Column dataType="string" dataField="Code_10_Location" caption="Code 10 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_1_Location" caption="Reference 1 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_2_Location" caption="Reference 2 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_3_Location" caption="Reference 3 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_4_Location" caption="Reference 4 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_5_Location" caption="Reference 5 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_6_Location" caption="Reference 6 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_7_Location" caption="Reference 7 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_8_Location" caption="Reference 8 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_9_Location" caption="Reference 9 Location" visible={false} />
                            <Column dataType="string" dataField="Reference_10_Location" caption="Reference 10 Location" visible={false} />
                            <Column dataType="datetime" dataField="Date_1_Location" caption="Date 1 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_2_Location" caption="Date 2 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_3_Location" caption="Date 3 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_4_Location" caption="Date 4 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_5_Location" caption="Date 5 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_6_Location" caption="Date 6 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_7_Location" caption="Date 7 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_8_Location" caption="Date 8 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_9_Location" caption="Date 9 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="datetime" dataField="Date_10_Location" caption="Date 10 Location" visible={false} format='MM/dd/yyyy'/>
                            <Column dataType="number" dataField="Quantity_1_Location" caption="Quantity 1 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_2_Location" caption="Quantity 2 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_3_Location" caption="Quantity 3 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_4_Location" caption="Quantity 4 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_5_Location" caption="Quantity 5 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_6_Location" caption="Quantity 6 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_7_Location" caption="Quantity 7 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_8_Location" caption="Quantity 8 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_9_Location" caption="Quantity 9 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataType="number" dataField="Quantity_10_Location" caption="Quantity 10 Location" visible={false} format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />


                            <GridToolbar>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(LocationHistoryList);